import { createSlice } from '@reduxjs/toolkit'
import { ping } from 'apps/formsCreationKit/store/reducers/settings/appSettings'

export const initialState = {
  pingInterval: 1000,
  builderType:
    (window.initialOnboardingState &&
      window.initialOnboardingState.builderType) ||
    'builder',
  projectSupport:
    (window.initialOnboardingState &&
      window.initialOnboardingState.projectSupport) ||
    false,
  featureSet: [],
}

export const workspaceConfigSettingsSliceExtraReducers = builder => {
  builder.addCase(ping.pending, state => {
    return {
      ...state,
      pingInterval: 30000,
    }
  })
}

export const workspaceConfigSettingsSliceConfig = {
  name: 'workspaceConfig',
  initialState: initialState,
  reducers: {},
  extraReducers: workspaceConfigSettingsSliceExtraReducers,
}

const workspaceConfigSettingsSlice = createSlice(
  workspaceConfigSettingsSliceConfig
)
export const {
  actions: workspaceConfigSettingsActions,
  reducer: workspaceConfigSettingsReducer,
} = workspaceConfigSettingsSlice
